/**
 * SeatingMapStep.jsx
 * Wizard step for configuring the synagogue seating map.
 * Shows a preview of the map and a button to open the full editor.
 */
import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import MapCanvas from '../../../business/SeatingMapWidget/MapCanvas';
import SeatingMapEditor from '../../SeatingMapEditor/SeatingMapEditor';
import { createDefaultMapData, migrateMapData, countSeats, countOccupied } from '../../../business/SeatingMapWidget/seatingMapUtils';

const navy = '#1e3a5f';

const SeatingMapStep = ({ formData, onChange }) => {
  const [editorOpen, setEditorOpen] = useState(false);
  const mapData = migrateMapData(formData?.mapData) || null;

  const handleSave = (newMapData) => {
    onChange({ mapData: newMapData });
    setEditorOpen(false);
  };

  return (
    <Box dir="rtl" sx={{ textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        הגדירו את מפת בית הכנסת — שורות מושבים, שמות, ומיקום ארון הקודש, בימה וכניסה.
      </Typography>

      {mapData ? (
        <>
          <Box sx={{
            border: '1px solid #e2e8f0',
            borderRadius: 2,
            p: 1,
            mb: 2,
            maxWidth: 400,
            mx: 'auto',
            bgcolor: '#fafafa',
          }}>
            <MapCanvas mapData={mapData} showNames />
          </Box>
          <Typography variant="body2" sx={{ mb: 1, color: '#666' }}>
            {countSeats(mapData)} מושבים | {countOccupied(mapData)} תפוסים
          </Typography>
        </>
      ) : (
        <Box sx={{
          border: '2px dashed #cbd5e1',
          borderRadius: 2,
          p: 4,
          mb: 2,
          maxWidth: 400,
          mx: 'auto',
        }}>
          <Typography variant="body2" color="text.secondary">
            לא הוגדרה מפה עדיין. לחצו למטה כדי ליצור אחת.
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        onClick={() => setEditorOpen(true)}
        sx={{
          bgcolor: navy,
          '&:hover': { bgcolor: '#152844' },
          fontWeight: 600,
          px: 4,
        }}
      >
        {mapData ? 'ערוך מפה' : 'צור מפה'}
      </Button>

      <SeatingMapEditor
        open={editorOpen}
        onClose={() => setEditorOpen(false)}
        initialMapData={mapData || createDefaultMapData()}
        onSave={handleSave}
      />
    </Box>
  );
};

export default SeatingMapStep;
